import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import CategorySkill from './CategorySkill';
import { Badge, Modal } from 'react-bootstrap';
import BookLessonSkill from './BookLessonSkill';
import { useBookContext } from './BookContext';
import { GameType } from '../../../ui/src/common/enums/enums';
import config from '../../../common-sk-doc/src/config';

const BookLesson: React.FC<{
  lesson: any;
}> = ({ lesson }) => {
  const { book } = useBookContext();
  const [valuePDF, setValuePDF] = useState<any>();

  const [searchParams, setSearchParams] = useSearchParams();
  const ref = useRef<HTMLDivElement>(null);
  const handleChangeLesson = () => {
    if (searchParams.get('lesson') === lesson.id) {
      searchParams.delete('lesson');
      setSearchParams(searchParams);
    } else {
      searchParams.delete('lesson');
      searchParams.set('lesson', lesson.id);
      setSearchParams(searchParams);
    }
    ref.current?.classList.add('collapsing');
    setTimeout(() => {
      ref.current?.classList.remove('collapsing');
    }, 350);
  };
  const lessonSelect = searchParams.get('lesson');

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
    setValuePDF([]);
  };

  const handleClickPDF = (value) => {
    setValuePDF(value);
    setShowModal(true);
  };
  const [numbersStart, setNumbersStart] = useState([]);
  useEffect(() => {
    if (lesson?.sections) {
      let _numbersStart = Array(lesson.sections.length)
        .fill(0)
        .map((el) => el);

      for (let i = 1; i < lesson.sections.length; i++) {
        if (lesson.sections[i].name) {
          _numbersStart[i] = 0;
        } else {
          _numbersStart[i] =
            _numbersStart[i - 1] +
            lesson.sections[i - 1].skills.length +
            lesson.sections[i - 1].sectionGames.length;
        }
      }
      setNumbersStart(_numbersStart);
    }
  }, [lesson]);

  return (
    <div
      className={`book-lesson ${lesson.id === lessonSelect ? 'lesson-active' : 'lesson-hide'
        }`}
      id={lesson.id}>
      <div
        className={`${book.type === 3
          ? 'lesson-name lesson-name-checkpoint'
          : 'lesson-name'
          } ${lesson.id === lessonSelect && 'active'}`}
        onClick={() => {
          handleChangeLesson();
        }}
        style={book.type === 3 ? { minHeight: '10vh' } : {}}>
        {lesson.name}
      </div>
      <div
        className="lesson-sections flex-grow-1"
        ref={ref}
      // style={{ maxHeight: lesson.id === lessonSelect ? '500px' : '0' }}
      >
        {lesson.sections.map((s, m) => (
          <div key={m} className="lesson-section">
            {s.name && <div className="section-name">{s.name}</div>}
            {s.skills.map((skill, n) => (
              <CategorySkill
                key={n}
                index={n + numbersStart[m]}
                skill={skill}
                showIndex
                lessonId={lesson.id}
              />
            ))}
            {s.sectionGames.map((game, n) => {
              return (
                <div
                  className={`minigame-name`}
                  style={{ marginLeft: '1.5rem' } }
                  key={n}>
                  {game.type === GameType.PDF ? (
                    <Badge className={'mx-2'}>📰</Badge>
                  ) : (
                    <Badge className={'mx-2'}>🎮</Badge>
                  )}
                  <span className="skill-number game-number">
                    {n + 1 + numbersStart[m]}.
                  </span>
                  {game.type === GameType.PDF ? (
                    <>
                      <span
                        className="game-name"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleClickPDF(game)}>
                        {game.name}
                      </span>
                      <Modal
                        show={showModal}
                        onHide={handleCloseModal}
                        backdrop="static"
                        size="xl"
                        contentClassName="modal-content-custom-show-PDF"
                        dialogClassName="modal-dialog-custom-show-PDF">
                        <Modal.Header
                          className="align-items-center"
                          style={{ padding: '0 1.75rem 0.5rem' }}
                          closeButton>
                          <img
                            style={{
                              width: '7%',
                              height: '12%',
                              marginTop: '-4px',
                            }}
                            src={
                              config.ASSETS_PATH +
                              '/images/book/pdf_dapan.svg'
                            }
                            alt=""
                          />
                          <span
                            className="ms-2"
                            style={{
                              fontSize: '20px',
                              color: '#284D64',
                            }}>
                            {valuePDF?.name}
                          </span>
                        </Modal.Header>
                        <Modal.Body
                          style={{
                            height: '95vh',
                          }}>
                          <iframe
                            src={valuePDF?.link}
                            title={valuePDF?.name || ''}
                            className="game-iframe"
                            frameBorder="0"
                            allowFullScreen={true}
                            width={'100%'}
                            height={'100%'}
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                          />
                        </Modal.Body>
                      </Modal>
                    </>
                  ) : (
                    <Link
                      to={`/game/${game.id}`}
                      className="game-name"
                      rel="noopener noreferrer"
                      style={{ color: '#00a9f0' }}>
                      {game.name}
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
        ))}

        <BookLessonSkill
          lesson={lesson}
        />
      </div>
    </div>
  );
};

export default BookLesson;
